import {
  ViewHeadline as ViewHeadlineIcon,
  ViewModule as ViewModuleIcon,
} from '@mui/icons-material'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { MouseEvent } from 'react'

import useUrlParams from '@/hooks/useUrlParams'
import removeNullishValues from '@/utils/removeNullishValues'

export type DisplayOptions = 'list' | 'grid'

export const GridListFilter = () => {
  const [{ display = 'grid' }, setSearchParams] = useUrlParams()

  const changeView = (_: MouseEvent, display: DisplayOptions) =>
    setSearchParams(removeNullishValues({ display: display ?? 'grid' }))

  return (
    <ToggleButtonGroup
      exclusive
      aria-label="display options as grid or list"
      sx={{ alignSelf: 'center' }}
      value={display}
      onChange={changeView}
    >
      <ToggleButton value="grid">
        <ViewModuleIcon />
      </ToggleButton>
      <ToggleButton value="list">
        <ViewHeadlineIcon />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}
